export default __webpack_public_path__ + "static/media/01.05a3bf38.jpg";